module.exports = __webpack_public_path__ + "assets/img/card.57eb01d3.svg";